import { Expose, Transform } from "class-transformer";

export class CreateConsumableDto {
  @Expose()
  name: string;

  @Expose()
  externalReference?: string;

  @Expose()
  externalCode?: string;

  @Expose()
  metricId: string;

  @Expose()
  categoryId: string;

  @Expose()
  subcategoryId: string;

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  minimumStock?: number;

  @Expose()
  archived: boolean;

  @Expose()
  isRepair?: boolean;
}
